/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_Teaser_EyebrowInputs */

const en_vc_onl_teaser_eyebrow = /** @type {(inputs: Vc_Onl_Teaser_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No install needed`)
};

const zh_vc_onl_teaser_eyebrow = /** @type {(inputs: Vc_Onl_Teaser_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无需安装`)
};

/**
* | output |
* | --- |
* | "No install needed" |
*
* @param {Vc_Onl_Teaser_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_teaser_eyebrow = /** @type {((inputs?: Vc_Onl_Teaser_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_Teaser_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_teaser_eyebrow(inputs)
	return zh_vc_onl_teaser_eyebrow(inputs)
});
export { vc_onl_teaser_eyebrow as "vc.onl.teaser.eyebrow" }